import type { Pinia } from 'pinia'
import { authApi } from '@/api/auth.api'
import { useAuthStore } from '@/stores/auth.store'

/**
 * App bootstrap performed before the first (guarded) navigation, so:
 *  1. the antiforgery cookie (hff_csrf) exists before any unsafe request — including the
 *     login/register POSTs — per M1-API-CONTRACT §Auth;
 *  2. the auth store knows the current session, so the router guard doesn't bounce an
 *     already-signed-in user to /login on a hard refresh.
 *
 * Both steps are best-effort: if the backend is unreachable, fetchSession() falls back to
 * 'anonymous' and guarded routes will redirect to /login as usual.
 */
export async function bootstrap(pinia: Pinia): Promise<void> {
  try {
    await authApi.csrf()
  } catch {
    // Cookie priming failed (backend down / dev proxy not up). Mutations will retry implicitly
    // once a real request sets the cookie; nothing else to do here.
  }

  const auth = useAuthStore(pinia)
  await auth.fetchSession()
}
